import { Head } from "@inertiajs/inertia-react";
import { CheckCircleIcon, CheckIcon, HomeIcon } from "@heroicons/react/outline";
import moment from "moment-timezone";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
const features = [
    {
        name: "TWAALF WEKEN online coaching door een DESKUNDIGE TRAINER",
        icon: CheckIcon,
    },
    {
        name: "VOEDINGSSCHEMA op maat, met verschillende mogelijkheden om te variëren.",
        icon: CheckIcon,
    },
    {
        name: "Om de vier weken een nieuw effectief trainingsschema",
        icon: CheckIcon,
    },
];

const bonusFeatures = [
    {
        name: "GRATIS E-book: Succesvol afvallen zonder voedingsschema",
        icon: CheckIcon,
    },
    {
        name: "GRATIS E-books: WE ARE COOKING – 28 hoofdgerechten, 15 smoothies, 21 tafelhapjes",
        icon: CheckIcon,
    },
    {
        name: "GRATIS 1 op 1 call, met Thierry van Melis voor al jouw persoonlijke vragen (30 minuten)",
        icon: CheckIcon,
    },
];

export default function Example() {
    const [countdown, setCountdown] = useState({
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    // Set the countdown timezone
    const countdownTimezone = "Europe/Amsterdam";

    // Update the countdown values every second
    useEffect(() => {
        const interval = setInterval(() => {
            // Get the current date and time in Amsterdam timezone
            const now = moment.tz(countdownTimezone);

            // Get the end time for the current day (00:00 in Amsterdam timezone)
            const endTime = moment
                .tz("00:00:00", "HH:mm:ss", countdownTimezone)
                .add(1, "day");

            // Calculate the time remaining until the end of the day
            const diff = endTime.diff(now);

            // Convert the time remaining to hours, minutes, and seconds
            const duration = moment.duration(diff);
            const hours = Math.floor(duration.asHours());
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            // Update the countdown state
            setCountdown({ hours, minutes, seconds });
        }, 1000);

        // Clear interval on unmount
        return () => clearInterval(interval);
    }, [countdownTimezone]);

    const order = () => {
        axios.post(route("order.store-temp"), {});
    };

    return (
        <div>
            <Head>
                <title>Succesvol afvallen zonder voedingsschema</title>
                <link
                    rel="canonical"
                    href={route("success-without-food-schema")}
                />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="In het boek ‘Succesvol afvallen zonder voedingsschema’ beschrijft Thierry van Melis van WE ARE welke stappen jij moet zetten om weer vol zekerheid door het leven te gaan."
                />
                <meta
                    property="og:description"
                    content="In het boek ‘Succesvol afvallen zonder voedingsschema’ beschrijft Thierry van Melis van WE ARE welke stappen jij moet zetten om weer vol zekerheid door het leven te gaan."
                />
                <meta
                    property="og:url"
                    content={route("success-without-food-schema")}
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Succesvol afvallen zonder voedingsschema - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/succesvol-afvallen-zonder-voedingsschema.png"
                />
            </Head>

            <div className="relative bg-black">
                <div className="overflow-hidden bg-black py-24 sm:py-32">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-y-16 gap-x-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                            <div className="lg:pr-8 lg:pt-4">
                                <div className="lg:max-w-lg">
                                    <h2 className="mt-2 text-5xl font-bold tracking-tight font-custom text-we-are-yellow sm:text-5xl">
                                        In shape voor de zomer!
                                    </h2>
                                    <p className="mt-6 text-lg leading-8 text-gray-100">
                                        Als je op zoek bent naar een effectieve
                                        en flexibele manier om je gezondheid en
                                        fitness te verbeteren, dan is dit online
                                        coaching programma iets voor jou!
                                        Gedurende twaalf weken word je begeleid
                                        door een deskundige trainer en ontvang
                                        je op maat gemaakte voedingsschema's,
                                        wekelijkse home workouts en
                                        ondersteuning van andere deelnemers in
                                        de gezamenlijke Facebook-groep.
                                        Hieronder vind je meer informatie over
                                        de verschillende aspecten van dit
                                        programma.
                                    </p>
                                    <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                                        {features.map((feature) => (
                                            <div
                                                key={feature.name}
                                                className="relative pl-9"
                                            >
                                                <dt className="inline font-semibold text-white">
                                                    <feature.icon
                                                        className="absolute top-1 left-1 h-5 w-5 text-green-600"
                                                        aria-hidden="true"
                                                    />
                                                    {feature.name}
                                                </dt>{" "}
                                                <dd className="inline">
                                                    {feature.description}
                                                </dd>
                                            </div>
                                        ))}
                                    </dl>
                                </div>
                            </div>
                            <img
                                src="/assets/personal-training-uden-schijndel.png"
                                // src="https://tailwindui.com/img/component-images/dark-project-app-screenshot.png"
                                alt="Product screenshot"
                                className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
                                width={2432}
                                height={1442}
                            />
                        </div>
                    </div>
                </div>
                {/*  */}
                <div className="bg-black py-24 sm:py-24">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl lg:max-w-none">
                            <div className="text-center">
                                <h2 className="text-5xl font-bold tracking-tight text-white">
                                    Deze aanbieding is geldig tot en met
                                </h2>
                                <p className="mt-4 text-lg leading-8 text-gray-100">
                                    Zodra de teller op 0 staat, is deze
                                    aanbieding niet meer geldig.
                                </p>
                            </div>
                            <dl className="mt-16 grid grid-cols-1 gap-0.5 overflow-hidden rounded-2xl text-center sm:grid-cols-3 lg:grid-cols-3">
                                <div className="flex flex-col bg-we-are-purple p-8">
                                    <dt className="text-2xl font-semibold leading-6 text-gray-100">
                                        uren
                                    </dt>
                                    <dd className="order-first text-3xl font-semibold tracking-tight text-gray-100">
                                        {countdown.hours}
                                    </dd>
                                </div>
                                <div className="flex flex-col bg-we-are-purple p-8">
                                    <dt className="text-2xl font-semibold leading-6 text-gray-100">
                                        minuten
                                    </dt>
                                    <dd className="order-first text-3xl font-semibold tracking-tight text-gray-100">
                                        {countdown.minutes}
                                    </dd>
                                </div>
                                <div className="flex flex-col bg-we-are-purple p-8">
                                    <dt className="text-2xl font-semibold leading-6 text-gray-100">
                                        seconden
                                    </dt>
                                    <dd className="order-first text-3xl font-semibold tracking-tight text-gray-100">
                                        {countdown.seconds}
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </div>
                {/*  */}

                <div className="bg-black py-10 sm:py-10">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="sm:text-center">
                            <h2 className="text-5xl font-semibold leading-12 text-white xs:text-center">
                                Normaal{" "}
                                <span className="text-red-600 xs:whitespace-nowrap">
                                    599 euro
                                </span>{" "}
                                <br className="hidden xs:block" />
                                NU <br className="hidden xs:block" />{" "}
                                <span className="text-green-500 xs:whitespace-nowrap">
                                    399 euro
                                </span>
                            </h2>
                        </div>

                        <div className="mx-auto mt-6 max-w-2xl text-center">
                            <a
                                href={route("orders-temp")}
                                className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2"
                            >
                                Ik doe mee
                            </a>
                        </div>
                    </div>
                </div>
                {/*  */}
                <div className="bg-black py-24 sm:py-32">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl lg:max-w-none">
                            <div className="text-center">
                                <h2 className="text-5xl font-bold tracking-tight text-white">
                                    Zij gingen je voor
                                </h2>
                                <p className="mt-4 text-lg leading-8 text-gray-100">
                                    Zodra de teller op 0 staat, is deze
                                    aanbieding niet meer geldig.
                                </p>
                            </div>

                            <ul
                                role="list"
                                className="grid mt-8 grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8"
                            >
                                {[...Array(12)].map((x, i) => (
                                    <li
                                        className="relative ml-0 p-2 lg:px-4"
                                        key={i}
                                    >
                                        <div
                                            className={
                                                "group block w-full aspect-w-10 aspect-h-10 rounded-lg bg-black"
                                            }
                                        >
                                            <picture>
                                                <source
                                                    srcSet={`/assets/transformations/webp/personal-training-uden-schijndel-${
                                                        1 + i
                                                    }.webp`}
                                                    width="960"
                                                    height="960"
                                                    type="image/webp"
                                                    alt={
                                                        "Transformatie " +
                                                        (1 + i)
                                                    }
                                                    className="object-cover pointer-events-none"
                                                />
                                                <source
                                                    srcSet={`/assets/transformations/personal-training-uden-schijndel-${
                                                        1 + i
                                                    }.jpg`}
                                                    width="960"
                                                    height="960"
                                                    type="image/jpeg"
                                                    alt={
                                                        "Transformatie " +
                                                        (1 + i)
                                                    }
                                                    className="object-cover pointer-events-none"
                                                />
                                                <img
                                                    src={`/assets/transformations/personal-training-uden-schijndel-${
                                                        1 + i
                                                    }.jpg`}
                                                    width="960"
                                                    height="960"
                                                    alt={
                                                        "Transformatie " +
                                                        (1 + i)
                                                    }
                                                    className="object-cover pointer-events-none"
                                                />
                                            </picture>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                {/* End transformations */}
                {/*  */}
                <div className="bg-black py-12">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl lg:max-w-none">
                            <div className="text-center">
                                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-4xl">
                                    Extra bonus!
                                </h2>
                                <p className="mt-4 text-lg leading-8 text-gray-100">
                                    Schrijf je binnen nu en 24 uur in en ontvang
                                    het volgende volledig gratis:
                                </p>
                            </div>
                            <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-7xl">
                                <dl className="grid grid-cols-1 gap-y-10 gap-x-8 lg:grid-cols-3 lg:gap-y-16">
                                    {bonusFeatures.map((feature) => (
                                        <div
                                            key={feature.name}
                                            className="relative pl-16"
                                        >
                                            <dt className="text-base font-medium leading-8 text-white">
                                                <div className="absolute top-0 left-0 flex h-10 w-10 items-center justify-center">
                                                    <feature.icon
                                                        className="h-10 w-10 text-green-600"
                                                        aria-hidden="true"
                                                    />
                                                </div>
                                                {feature.name}
                                            </dt>
                                            <dd className="mt-2 text-base leading-7 text-gray-600">
                                                {feature.description}
                                            </dd>
                                        </div>
                                    ))}
                                </dl>
                            </div>
                            <dl className="mt-16 grid grid-cols-1 gap-0.5 overflow-hidden rounded-2xl text-center sm:grid-cols-3 lg:grid-cols-3">
                                <div className="flex flex-col bg-we-are-purple p-8">
                                    <dt className="text-2xl font-semibold leading-6 text-gray-100">
                                        uren
                                    </dt>
                                    <dd className="order-first text-3xl font-semibold tracking-tight text-gray-100">
                                        {countdown.hours}
                                    </dd>
                                </div>
                                <div className="flex flex-col bg-we-are-purple p-8">
                                    <dt className="text-2xl font-semibold leading-6 text-gray-100">
                                        minuten
                                    </dt>
                                    <dd className="order-first text-3xl font-semibold tracking-tight text-gray-100">
                                        {countdown.minutes}
                                    </dd>
                                </div>
                                <div className="flex flex-col bg-we-are-purple p-8">
                                    <dt className="text-2xl font-semibold leading-6 text-gray-100">
                                        seconden
                                    </dt>
                                    <dd className="order-first text-3xl font-semibold tracking-tight text-gray-100">
                                        {countdown.seconds}
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </div>
                {/*  */}

                <div className="mx-auto mt-6 max-w-2xl sm:text-center pb-32">
                    <div className="mx-auto text-center">
                        <a
                            href={route("orders-temp")}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Ik doe mee
                        </a>
                        <div className="mt-4">
                            <span className="text-gray-300">
                                (Nu eenmalig{" "}
                                <span className="text-green-500">399 euro</span>
                                )
                            </span>
                        </div>
                    </div>
                </div>
                {/*  */}
            </div>
        </div>
    );
}
